import { ToursSearchParams } from '@model/search';
import {
  AirportsSearchParams,
  searchAirports,
  searchGeography,
  searchHelpArticles,
  searchToursByType,
  setAirportsQuery,
  setGeographyQuery,
  setHelpArticlesQuery,
  setToursQueryByType
} from '@state/slices/algolia/algoliaSlice';
import { createListener } from '@state/store/createListener';

/* *************** *
 *   LISTENERS     *
 * *************** */
export const setupAlgoliaListeners = () => {
  createListener([setGeographyQuery], async (action, listenerApi) => {
    listenerApi.dispatch(searchGeography(<string>action.payload));
  });

  createListener([setAirportsQuery], async (action, listenerApi) => {
    listenerApi.dispatch(searchAirports(<AirportsSearchParams>action.payload));
  });

  createListener([setHelpArticlesQuery], async (action, listenerApi) => {
    listenerApi.dispatch(searchHelpArticles(<string>action.payload));
  });

  createListener([setToursQueryByType], async (action, listenerApi) => {
    listenerApi.dispatch(searchToursByType(<ToursSearchParams>action.payload));
  });
};
